exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".breadcrumb-root-bce04{color:#999}.breadcrumb-root-bce04.breadcrumb-vertical-mode-6f9fc>*{font-size:12px}.breadcrumb-root-bce04.breadcrumb-vertical-mode-6f9fc>:nth-last-child(2) .ant-breadcrumb-separator{display:none}.breadcrumb-root-bce04.breadcrumb-vertical-mode-6f9fc>:last-child{display:block;font-size:16px;color:#666}", ""]);

// Exports
exports.locals = {
	"root": "breadcrumb-root-bce04",
	"vertical-mode": "breadcrumb-vertical-mode-6f9fc",
	"verticalMode": "breadcrumb-vertical-mode-6f9fc"
};